<template lang="pug">
    section
        tabs(:items="tabs" :active-tab="$route.fullPath" @click="activateTab")
            template(slot="tabbar-buttons")
                el-button.delete-button(
                    circle v-if="! loading && isDeletable && checkRestrictions('ex:shop:stocks', 'update')"
                    type="danger"
                    icon="el-icon-fa-trash-alt far"
                    :loading="deleting"
                    :disabled="isDisabledSubmit && ! deleting"
                    @click="deleteCurrentStock"
                )
                el-button(
                    circle icon="el-icon-fa-times fas"
                    :disabled="isDisabledSubmit"
                    @click="leave"
                )
                el-button(
                    circle v-if="! loading && checkRestrictions('ex:shop:stocks', 'update')"
                    type="primary"
                    icon="el-icon-fa-check fas"
                    :disabled="isDisabledSubmit && ! savingAndClose"
                    :loading="savingAndClose"
                    @click="submit($event, listRoute)"
                )
                el-button(
                    circle v-if="! loading && checkRestrictions('ex:shop:stocks', 'update')"
                    type="success"
                    icon="el-icon-fa-save fas"
                    :disabled="isDisabledSubmit && ! saving"
                    :loading="saving"
                    @click="submit"
                )
        el-card(shadow="always" v-loading="loading")
            el-form(
                v-if="form"
                :model="form"
                :rules="rules"
                ref="form"
                :disabled="sharedShopDataReadOnly"
            )
                .flex-row
                    el-form-item.grow(:label="$t('Name')" prop="name")
                        el-input(
                            :value="form.name"
                            maxlength="255"
                            @input="value => set({ path: 'form.name', value })"
                            show-word-limit
                        )
                    el-form-item(:label="$t('Key')" prop="key")
                        el-input(
                            :value="form.key"
                            maxlength="255"
                            @input="value => set({ path: 'form.key', value })"
                            show-word-limit
                        )
                    el-form-item(:label="$t('Status')" prop="status")
                        el-select.is-full-width(
                            :value="form.status"
                            placeholder=""
                            @change="value => set({ path: 'form.status', value })"
                        )
                            el-option(
                                v-for="(item, key) in options.status.items"
                                :key="key"
                                :label="$t(item.label)"
                                :value="item.value"
                            )
                transition(name="slide-decent-vertical" mode="out-in")
                    .address-card-wrapper(v-if="form.address && !form.address.deleted" key="address")
                        el-button.remove-btn(
                            plain
                            circle
                            size="mini"
                            type="danger"
                            icon="el-icon-fa-trash-alt fas"
                            @click="set({ path: 'form.address.deleted', value: true })"
                        )
                        AddressCardInput(
                            :form="form"
                            formPath="address"
                            propPath="address"
                            :fields="['company', 'phone', 'street', 'zipcode', 'city', 'country']"
                        )
                    .add-address(v-else key="add-address")
                        el-button(
                            type="primary"
                            icon="el-icon-fa-plus fas"
                            @click="addAddress"
                        ) {{ $t('Add Address') }}
                .restriction.flex-row
                    el-form-item(:label="$t('Available for')" prop="restriction")
                        el-select.is-full-width(
                            :value="form.restriction"
                            placeholder=""
                            @change="value => set({ path: 'form.restriction', value })"
                            autocomplete="no-fill"
                        )
                            el-option(
                                v-for="({ label, value }) in options.restriction.items"
                                :key="value"
                                :label="$t(label)"
                                :value="value"
                            )
                    transition(name="slide-decent-left")
                        el-form-item.custom-label.grow(
                            v-if="form.restriction === 'customer-groups'"
                            :label="$t('Customer groups')"
                            prop="customerGroups"
                        )
                            el-select.is-full-width(
                                placeholder=""
                                :value="form.customerGroups"
                                multiple
                                clearable
                                filterable
                                value-key="id"
                                autocomplete="no-fill"
                                @change="value => set({ path: 'form.customerGroups', value })"
                            )
                                el-option(
                                    v-for="group in options.customerGroup.items"
                                    :key="group.id"
                                    :label="group.name"
                                    :value="group"
                                )
                p(v-if="needsUps")
                    el-form-item(:label="$t('UPS account number (6 digits)')")
                        el-input(v-model="upsAccountNumber")
        .form-buttons
            el-button(
                round v-if="! loading && checkRestrictions('ex:shop:stocks', 'update')"
                icon="el-icon-fa-times fas"
                :disabled="isDisabledSubmit"
                @click="leave"
            ) {{ $t('Dismiss') }}
            el-button(
                round v-if="! loading && checkRestrictions('ex:shop:stocks', 'update')"
                type="primary"
                icon="el-icon-fa-check fas"
                :loading="savingAndClose"
                :disabled="isDisabledSubmit && ! savingAndClose"
                @click="submit($event, listRoute)"
            ) {{ $t('Save and close') }}
            el-button(
                round v-if="! loading && id && checkRestrictions('ex:shop:stocks', 'update')"
                type="success"
                icon="el-icon-fa-save fas"
                :loading="saving"
                :disabled="isDisabledSubmit && ! saving"
                @click="submit"
            ) {{ $t('Save') }}
</template>

<i18n>
    {
        "de": {
            "Stocks": "Lager",
            "Stock saved successfully!": "Lager wurde erfolgreich gespeichert",
            "Stock could not be saved.": "Lager konnte nicht gespeichert werden",
            "Stock deleted successfully!": "Lager wurde erfolgreich gelöscht",
            "Stock could not be deleted.": "Lager konnte nicht gelöscht werden",
            "Name": "Name",
            "Key": "Schlüssel",
            "First name": "Vorname",
            "Last name": "Nachname",
            "Email": "E-Mail",
            "Phone": "Telefon",
            "Mobile": "Handy",
            "Company": "Firma",
            "Mr.": "Herr",
            "Mrs.": "Frau",
            "Street": "Straße",
            "Zipcode": "PLZ",
            "City": "Ort",
            "Country": "Land",
            "Undefined": "Unbekannt",
            "Add Address": "Addresse hinzufügen",
            "Remove Address": "Addresse entfernen",
            "Available for": "Verfügbar für",
            "Customer groups": "Kundengruppen",
            "Anyone": "Jeden",
            "Guests": "Gäste",
            "Customer Groups": "Kundengruppen",
            "UPS account number (6 digits)": "UPS-Account-Nr. (sechsstellig)"
        }
    }
    </i18n>

<script>
import _ from 'lodash'
import uniqid from 'uniqid';

import { checkRestrictions } from '@/helpers'
import { useSetupStore, useShopStockStore } from '@/stores'

import Tabs from '@/components/Tabs';
import AddressCardInput from '@/components/AddressCardInput';

import router from '@/router';

export default {
    name: "StockForm",
    data() {
        return {
            listRoute: { name: 'settings-stocks' },
            loading: false,
            error: false,
            saving: false,
            deleting: false,
            savingAndClose: false
        }
    },
    components: {
        Tabs,
        AddressCardInput
    },
    computed: {
        tabs() {
            const id = this.$route.params.id;
            const tabs = [
                {
                    name: this.$t('Stocks'),
                    path: `/stock/${id}`,
                    icon: {
                        name: 'file',
                        group: 'fas'
                    }
                }
            ];
            return tabs;
        },
        id() {
            return _.get(this.form, 'id', false);
        },
        isDeletable() {
            return !!this.id;
        },
        isDisabledSubmit() {
            return this.saving || this.savingAndClose || this.deleting;
        },
        template() {
            return _.get(this.activeCms, 'config.template')
        },
        requirements() {
            return _.get(this.template, 'requirements') || []
        },
        needsUps() {
            return !!this.requirements.find(requirement => {
                return requirement.key === 'ups-account-nr' && requirement.context === 'shop'
            })
        },
        upsAccountNumber: {
            get() {
                if (this.form.metas && this.form.metas.find(item => item.key == "ups-account-nr")) {
                    return this.form.metas.find(item => item.key == "ups-account-nr").value
                }
            },
            set(value) {
                this.setUpsNr(value)
            }
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        },
        setupStore() {
            return useSetupStore();
        },
        stockStore() {
            return useShopStockStore();
        },
        form() {
            return this.stockStore.form;
        },
        rules() {
            return this.stockStore.computedRules;
        },
        options() {
            return this.stockStore.options;
        },
    },
    methods: {
        initialize() {
            let dependencies = []
            if (this.$route.params.id === 'new') {
                this.resetForm();
            } else if (!isNaN(this.$route.params.id)) {
                dependencies.push(this.fetchStock(this.$route.params.id))
            }

            dependencies.push(this.fetchCustomerGroupOptions(this.activeCms.shop.id))
            const fetchDependencies = () => Promise.all(dependencies);

            this.error = false;
            this.loading = true;

            const handleDependencyError = err => {
                const { graphQLErrors } = err

                let code = 501;
                let message = 'An error occurred!';

                if (graphQLErrors) {
                    code = _.get(graphQLErrors, '0.code') || code;
                    message = _.get(graphQLErrors, '0.message') || message;
                }

                let notify = true;
                switch (code) {
                    case 401:
                        notify = false;
                        this.error = { code, message: 'You are not authorized' };
                        break;
                    case 403:
                        notify = false;
                        this.error = { code, message: 'You are not allowed to be here' };
                        break;
                    // case 404:
                    //     break;
                    default:
                        this.error = true;
                        break;
                }

                if (notify) {
                    this.$notify.error({
                        title: this.$t(message),
                        message: this.$t('Dependencies could not be fetched.'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }

                this.loading = false;

                console.error(err);
            }

            fetchDependencies()
                .catch(handleDependencyError)
                .finally(() => {
                    this.loading = false;
                });
        },
        fetch() {
        },
        // update(key, event) {
        //     this.updateForm(
        //         {
        //             path: [key],
        //             value: event
        //         }
        //     )
        // },
        addAddress() {
            this.set({
                path: 'form.address',
                value: {
                    id: _.get(this.form, 'address.id') || uniqid('new:'),
                    company: '',
                    phone: '',
                    street: '',
                    zipcode: '',
                    city: '',
                    country: 'DE',
                    latitude: null,
                    longitude: null
                }
            })
        },
        deleteCurrentStock() {
            this.deleting = true;
            this.deleteStock(this.id)
                .then(() => {
                    // this.deleting = false

                    router.push(this.listRoute);

                    this.$notify.success({
                        title: this.$t('Stock deleted successfully!'),
                        iconClass: 'fas el-icon-fa-check',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                })
                .catch(err => {
                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);

                    this.deleting = false;

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Stock could not be deleted.'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                });
        },
        submit(event, redirect = false) {
            this.$refs.form.validate((valid, errors) => {
                if (valid) {
                    if (redirect) this.savingAndClose = true;
                    else this.saving = true;

                    let save = this.createStock;
                    if (this.id) save = this.updateStock;
                    this.loading = true
                    save(this.form)
                        .then(stock => {
                            if (redirect) this.savingAndClose = false;
                            else this.saving = false;

                            this.$notify.success({
                                title: this.$t('Stock saved successfully!'),
                                iconClass: 'fas el-icon-fa-check',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });

                            if (redirect) {
                                router.push(redirect);
                            } else {
                                if (this.$route.params.id === 'new') {
                                    const route = router.currentRoute
                                    route.params.id = stock.id
                                    router.replace(route)
                                }
                            }
                        })
                        .catch(err => {
                            console.error(err);

                            if (redirect) this.savingAndClose = false;
                            else this.saving = false;

                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Stock could not be saved.'),
                                iconClass: 'fas el-icon-fa-xmark',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                        }).finally(() => {
                            this.loading = false;
                        });
                } else {
                    this.$notify.warning({
                        title: this.$t('Form is not valid!'),
                        message: this.$t('Correct your input and submit again.'),
                        iconClass: 'fas el-icon-fa-exclamation-circle',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }
            })
        },
        leave() {
            router.push(this.listRoute);
        },
        checkRestrictions,
        activateTab(item) {
            return this.setupStore.activateTab(item);
        },
        fetchStock(stockId) {
            return this.stockStore.fetchStock(stockId);
        },
        fetchCustomerGroupOptions(shopID) {
            return this.stockStore.fetchCustomerGroupOptions(shopID);
        },
        createStock(stock) {
            return this.stockStore.create(stock);
        },
        updateStock(stock) {
            return this.stockStore.update(stock);
        },
        deleteStock(id) {
            return this.stockStore.delete(id);
        },
        resetForm() {
            this.stockStore.resetForm();
        },
        set(payload) {
            this.stockStore.setState(payload);
        },
        setUpsNr(value) {
            this.stockStore.setUpsNr(value);
        },
    },
    mounted() {
        this.initialize();
    }
}
</script>

<style lang="sass" scoped>
.top-buttons
    display: flex
    justify-content: flex-end
    padding-bottom: 4px
.restriction
    margin-top: 1rem
.address-card-wrapper
    position: relative
    margin: 1rem 0

    .remove-btn
        position: absolute
        top: -8px
        right: -8px
        z-index: 10
.add-address
    margin: 1rem 0
</style>
